import { render } from "./MangoGamePage.vue?vue&type=template&id=6dfe7f5c&scoped=true"
import script from "./MangoGamePage.vue?vue&type=script&lang=js"
export * from "./MangoGamePage.vue?vue&type=script&lang=js"

import "./MangoGamePage.vue?vue&type=style&index=0&id=6dfe7f5c&scoped=true&lang=css"
import "./MangoGamePage.vue?vue&type=style&index=1&id=6dfe7f5c&lang=css"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-6dfe7f5c"]])

export default __exports__